import { autoMount } from '../../../utils/autoMount';
import { SearchSection } from '../../../components/organisms/searchSection';

autoMount({ SearchSection });
